// Lightweight helper that resolves the browser's current GPS position into
// `{ lat, lng, source }` for the location-log payload. Never rejects — if
// geolocation is denied, unsupported, or times out, resolves with
// `{ lat: null, lng: null, source: 'denied'|'unavailable'|'timeout' }` so
// the caller can still ship the request and let the backend record a
// "location unavailable" log entry.

export function getCurrentPositionOnce(timeoutMs = 6000) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !("geolocation" in navigator)) {
      resolve({ lat: null, lng: null, source: "unavailable" });
      return;
    }
    let done = false;
    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      resolve({ lat: null, lng: null, source: "timeout" });
    }, timeoutMs + 500);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          source: "gps",
        });
      },
      (err) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        const src = err?.code === 1 ? "denied" : err?.code === 3 ? "timeout" : "unavailable";
        resolve({ lat: null, lng: null, source: src });
      },
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 30_000 },
    );
  });
}
